<template>
    <v-container>
        <ModuleClosedAlert module="site.plan_adherence" />
        <div class="limiter-content pa-2 pa-lg-0">
            <v-row>
                <v-col>
                    <div class="font-weight-bold mt-10 title-page" tabindex="0">Adesão ao Plano</div>
                </v-col>
            </v-row>

            <br />

            <div class="mt-4" v-if="dataset.loading">
                <v-progress-circular indeterminate color="primary" :size="50"></v-progress-circular>
            </div>

            <br />

            <div v-html="dataset.description" tabindex="0"></div>

            <v-container v-if="!loadingInitial">

                <v-container v-if="user && !dataset.loading">

                    <v-row v-if="!dataset.confirmedRead" no-gutters class="mb-4">
                        <v-col>
                            <div class="plan-pdf-viewer mb-5">
                                <div class="plan-pdf-toolbar">
                                    <div>
                                        <div class="text-subtitle-2 font-weight-bold primary--text">
                                            Plano de Recuperação Judicial
                                        </div>
                                        <div class="text-caption grey--text text--darken-1">
                                            Leia o documento antes de confirmar a adesão.
                                        </div>
                                    </div>
                                    <div class="plan-pdf-actions">
                                        <v-btn small outlined color="primary" class="mr-2" @click="openPlanPdf">
                                            <v-icon left small>mdi-open-in-new</v-icon>
                                            Abrir plano
                                        </v-btn>
                                        <v-btn small text color="primary" @click="savePdfFromIframe">
                                            <v-icon left small>mdi-download-outline</v-icon>
                                            Baixar termo
                                        </v-btn>
                                    </div>
                                </div>

                                <iframe class="plan-pdf-frame" :src="planViewerUrl" title="Plano de Recuperação Judicial"
                                    frameborder="0" @error="dataset.pdfLoadError = true"></iframe>
                            </div>

                            <span v-if="dataset.pdfLoadError" class="error-text">Erro ao carregar documento de
                                adesão.</span>

                            <br>
                            <br>
                            <v-checkbox :rules="[$rules.required]" v-model="dataset.confirmReadPlan" class="mt-0">
                                <template v-slot:label>
                                    <div style="font-size: 14px; text-align: justify;">
                                        Confirmo que li o Plano de Recuperação Judicial por inteiro e estou
                                        ciente sobre as cláusulas apresentadas pelo Grupo 123 Milhas e as opções de
                                        pagamento ofertadas para os credores da Recuperação Judicial;
                                    </div>
                                </template>
                            </v-checkbox>

                            <v-checkbox v-model="dataset.acceptResponsibility" class="mt-0">
                                <template v-slot:label>
                                    <div style="font-size: 14px; text-align: justify;">
                                        Declaro que sou o titular das informações preenchidas nesta plataforma ou possuo
                                        poderes atribuídos para utilização dos dados, sendo responsável pelo
                                        preenchimento
                                        adequado e verdadeiro dos dados, sob as penas da Lei;
                                    </div>
                                </template>
                            </v-checkbox>

                            <v-checkbox v-model="dataset.acceptTerms" class="mt-0">
                                <template v-slot:label>
                                    <div style="font-size: 14px; text-align: justify;">
                                        Estou ciente de que a adesão ao Plano de Recuperação Judicial através desta
                                        plataforma implica a consideração por parte da Administração Judicial e do Juízo
                                        da
                                        Recuperação
                                        Judicial de que sou favorável à aprovação do Plano de Recuperação Judicial das
                                        Empresas 123 VIAGENS E TURISMO LTDA. (CNPJ: 26.669.170/0001-57), ART VIAGENS E
                                        TURISMO LTDA.
                                        (CNPJ: 11.442.110/0001-20), NOVUM INVESTIMENTOS PARTICIPAÇÕES S.A. (CNPJ:
                                        26.941.940/0001-79), LH - LANCE HOTEIS LTDA. (CNPJ: 24.813.491/0001-58) e MM
                                        TURISMO
                                        & VIAGENS S.A.
                                        (CNPJ: 16.988.607/0001-61);
                                    </div>
                                </template>
                            </v-checkbox>

                            <v-checkbox v-model="dataset.acceptRemoveAdhesionAgc" class="mt-0">
                                <template v-slot:label>
                                    <div style="font-size: 14px; text-align: justify;">
                                        Estou ciente de que, conforme disposto no Termo de Adesão, a assinatura deste
                                        Termo de Adesão pelo Credor importa aceite irrevogável e irretratável a todos os
                                        termos do Plano de Recuperação Judicial, desde que a versão do plano de
                                        recuperação judicial submetida à aprovação dos credores e à homologação do juízo
                                        recuperacional reflita exatamente as condições de pagamento aplicáveis ao Credor
                                        previstas no Plano apresentado no dia 26/12/2024, ao qual o Credor adere na
                                        presente data, não sendo possível a alteração de sua manifestação em
                                        Assembleia-Geral de Credores.
                                    </div>
                                    <!-- <div style="font-size: 14px; text-align: justify;">
                                        Estou ciente de que posso retirar a adesão durante a Assembleia Geral de Credores,
                                        se desejar,
                                        desde que esteja regularmente credenciado e tenha comparecido durante a instalação
                                        do Ato.
                                    </div> -->
                                </template>
                            </v-checkbox>

                            <v-alert v-if="!allCheckmarksChecked" type="warning" outlined dense border="left"
                                class="mb-4">
                                Para prosseguir, leia atentamente e, se estiver de acordo, marque todas as opções acima.
                            </v-alert>

                            <v-btn color="primary" :disabled="!allCheckmarksChecked" @click="readAndAgreePlan()">
                                Prosseguir
                            </v-btn>
                        </v-col>
                    </v-row>

                    <br>

                    <v-alert v-if="!hasCreditor && dataset.confirmedRead" type="info" outlined>
                        Você não está relacionado na lista de credores e desta forma, não poderá seguir com a Adesão ao
                        Plano.
                    </v-alert>

                    <v-alert v-else-if="!dataset.allowedSignature && hasCreditor && dataset.confirmedRead" type="info"
                        outlined>
                        Há um pedido de revisão de crédito em aberto, portanto, não será possível prosseguir com a
                        adesão ao
                        plano.
                    </v-alert>

                    <v-alert
                        v-else-if="dataset.allowedSignature && hasCreditor && isUserDataIncomplete && dataset.confirmedRead"
                        type="warning" border="left" color="warning" elevation="2" dense class="text--primary">
                        {{ alertMessage }}
                        <v-btn text small color="primary" class="font-weight-bold ml-1"
                            @click="profileModal = true">
                            Completar cadastro
                        </v-btn>
                    </v-alert>

                    <template
                        v-else-if="dataset.allowedSignature && this.hasMoreClass && this.hasMoreClass.length >= 2 && dataset.confirmedRead">
                        <v-alert type="info" border="left" color="info" elevation="2" dense>
                            Você está relacionado em mais de uma classe. Selecione a classe que deseja utilizar para
                            realizar a adesão ao plano.
                        </v-alert>

                        <v-select v-model="selectedClass" :items="hasMoreClass" item-text="name" item-value="id"
                            label="Selecione a Classe" dense outlined class="mt-4" @change="onClassChanged">
                            <template v-slot:item="data">
                                <v-list-item-content>
                                    <v-list-item-title>
                                        Classe {{ data.item.name }}
                                    </v-list-item-title>
                                </v-list-item-content>
                            </template>
                        </v-select>

                        <v-btn color="primary" class="mt-3" :disabled="!showButtonConfirm"
                            @click="confirmSelectedClass">
                            Confirmar Classe
                        </v-btn>
                        <br>
                    </template>
                    <br>
                    <template>
                        <div v-if="dataset.loading" class="text-center">
                            <v-progress-circular indeterminate color="primary" :size="50"></v-progress-circular>
                        </div>
                        <div v-else-if="showProcessedContent && processedContent && dataset.confirmedRead">
                            <v-divider></v-divider>
                            <br>
                            <v-card class="pa-4" color="grey lighten-5" flat>
                                <div v-html="processedContent" tabindex="0"></div>
                            </v-card>

                            <v-row class="mt-6">
                                <v-col cols="12">
                                    <v-card outlined class="pa-3">
                                        <v-row align="center">
                                            <v-col :cols="dataset.adherence && dataset.adherence.status === 1 ? '7' : '12'">
                                                <v-card-title class="font-weight pb-2 pl-3">
                                                    Status da adesão:
                                                </v-card-title>
                                                <v-card-text class="pt-0 pl-3">
                                                    <v-alert
                                                        v-if="dataset.adherence && dataset.adherence.status !== null && dataset.adherence.status !== undefined"
                                                        :color="getColorByStatus(dataset.adherence.status)" text-color="white"
                                                        rounded="pill" dense dark class="mt-4 d-inline-block px-4 py-2"
                                                        tabindex="0">
                                                        {{ getTextByStatus(dataset.adherence.status) }}
                                                    </v-alert>
                                                    <v-alert v-else color="grey lighten-1" text-color="white" rounded="pill"
                                                        dense dark class="mt-4"
                                                        style="max-width: 300px; height: 35px; display: inline-flex; align-items: center; justify-content: center;"
                                                        tabindex="0">
                                                        Nenhuma informação disponível
                                                    </v-alert>

                                                    <p v-if="!dataset.adherence.validation_result && dataset.adherence.status === 0">
                                                        Aguardando envio do documento assinado digitalmente.
                                                    </p>
                                                    <p v-else-if="Object.keys(dataset.adherence).length === 0">
                                                        Documento de adesão ao plano não encontrado ou ainda não gerado.
                                                    </p>
                                                    <p v-else>
                                                        {{ dataset.adherence.validation_result }}
                                                    </p>
                                                </v-card-text>
                                            </v-col>

                                            <template v-if="dataset.adherence && dataset.adherence.status === 1">
                                                <v-divider vertical class="my-4"></v-divider>

                                                <v-col class="px-6">
                                                    <div class="text-subtitle-1 font-weight-bold mb-2">
                                                        Deseja manifestar interesse na troca da opção?
                                                    </div>
                                                    <p class="body-2 grey--text text--darken-1">
                                                        Clique no botão abaixo para manifestar interesse em trocar sua opção escolhida na adesão
                                                    </p>
                                                    
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn 
                                                                color="primary" 
                                                                outlined 
                                                                v-bind="attrs" 
                                                                v-on="on"
                                                                @click="handleInterestChange"
                                                            >
                                                                <v-icon left>mdi-swap-horizontal</v-icon>
                                                                Manifestar Interesse
                                                            </v-btn>
                                                        </template>
                                                        <span>Clique neste botão para manifestar interesse em trocar sua opção escolhida na adesão</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </template>
                                        </v-row>
                                    </v-card>
                                </v-col>
                            </v-row>

                            <v-row class="mt-6">
                                <v-col cols="12" sm="6">
                                    <div class="d-flex align-center">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn color="primary" v-bind="attrs" v-on="on"
                                                    :loading="dataset.downloading"
                                                    :disabled="dataset.loading || dataset.downloading || (dataset.adherence && dataset.adherence.status === 1)"
                                                    @click="showSignatureInfo = true">
                                                    {{ dataset.adherence.status == null ? 'Gerar PDF' : 'Gerar novo PDF'
                                                    }}
                                                </v-btn>
                                            </template>
                                            <span>Gerar documento PDF para ser assinado</span>
                                        </v-tooltip>

                                        <v-tooltip v-if="dataset.adherence && dataset.adherence.status !== 1" bottom max-width="400">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon small class="ml-2" color="grey darken-1" v-bind="attrs"
                                                    v-on="on" @click="showHelpSignature = true">
                                                    <v-icon>mdi-help-circle-outline</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Ajuda para assinar digitalmente o documento</span>
                                        </v-tooltip>

                                    </div>
                                </v-col>

                                <v-col cols="12" sm="6">
                                    <v-file-input v-model="signedPdf" label="Clique aqui para enviar o PDF Assinado"
                                        accept="application/pdf" :loading="dataset.uploading" :truncate-length="50"
                                        :disabled="dataset.loading || dataset.uploading || !dataset.adherence || dataset.adherence.status === null || dataset.adherence.status === undefined || dataset.adherence.status === 1"
                                        prepend-icon="mdi-upload" @change="uploadPdf">
                                    </v-file-input>
                                </v-col>
                            </v-row>
                        </div>
                    </template>
                </v-container>

                <div class="mt-10" v-if="!user">
                    <h4>Por favor, realize o seu login para ter acesso à Adesão ao Plano.</h4>
                </div>

            </v-container>

        </div>

        <v-dialog v-if="dataset.allowedSignature && dataset.confirmedRead && showClassOptionModal"
            v-model="showClassOptionModal" max-width="900px" persistent>
            <v-card>
                <v-card-title class="headline font-weight-bold primary--text">
                    {{ getClassTitle(selectedClassType) }}
                </v-card-title>
                <v-card-text>
                    <p class="mb-6">
                        Selecione uma das opções disponíveis. Ao selecionar, o descritivo da opção será exibido.
                    </p>
                    <v-select class="mb-4" label="Selecione uma opção" :items="getOptionsByClass(selectedClassType)"
                        item-text="text" item-value="value" v-model="optionSelect" outlined dense>
                    </v-select>
                    <v-card v-if="optionSelected" class="pa-4 grey lighten-4" outlined elevation="1">
                        <v-card-title class="subtitle-1 font-weight-bold">
                            Detalhes da Opção Selecionada
                        </v-card-title>
                            <v-card-text>
                                <div
                                    style="max-height: 300px; overflow-y: auto;"
                                    v-html="getOptionLongText"
                                >
                                    
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" :disabled="!optionSelect" @click="confirmOption">
                        Confirmar Seleção
                    </v-btn>
                    <v-btn text @click="showClassOptionModal = false">
                        Fechar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <user-profile-edit-modal v-model="profileModal" @saved="handleProfileSaved" />

        <v-dialog v-model="interestDialog.show" max-width="600px" persistent>
            <v-card>
                <v-card-title class="headline primary white--text">
                 Manifestar Troca Opção
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="interestDialog.show = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="mt-4">
                    
                    <div class="pa-4 mb-6 rounded-lg" style="background-color: #f1f5f9; border-left: 4px solid #64748b;">
                        <div class="grey--text text--darken-2 caption font-weight-bold text-uppercase mb-1">
                            Opção Atual: <strong>{{ currentOptionText() }}</strong>
                        </div>  
                       
                    </div>

                    <div v-if="interestDialog.selectedClass" class="mt-4">
                        <span class="grey--text text--darken-2 caption font-weight-bold text-uppercase mb-3">
                            Selecione a nova Opção
                        </span>
                        <v-select v-model="interestDialog.selectedOption" :items="interestDialog.availableOptions"
                            item-text="text" item-value="value" label="Opção de pagamento" dense outlined
                            class="mt-3" no-data-text="Nenhuma opção encontrada para esta classe">
                            <template v-slot:item="{ item }">
                                <v-list-item-content>
                                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                                </v-list-item-content>
                            </template>
                        </v-select>
                    </div>

                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" text @click="interestDialog.show = false">
                        Cancelar
                    </v-btn>
                    <v-btn color="primary" :disabled="!interestDialog.selectedClass || !interestDialog.selectedOption"
                        :loading="interestDialog.loading" @click="submitInterestChange">
                        Confirmar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <!-- Infos procedimento assinatura antes de gerar o PDF -->
        <v-dialog v-model="showSignatureInfo" max-width="650" persistent>
            <v-card>

                <v-card-title class="headline d-flex align-center pb-2 blue darken-4 white--text">
                    <v-icon color="white" large class="mr-3">mdi-draw-pen</v-icon>
                    Assinatura Termo de Adesão
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="showSignatureInfo = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-sheet color="orange darken-2" class="px-4 py-2 d-flex align-center justify-center">
                    <v-icon color="white" class="mr-2">mdi-alert</v-icon>
                    <span class="white--text font-weight-bold text-uppercase body-1">
                        Atenção
                    </span>
                </v-sheet>

                <v-card-text class="pt-4">
                    <v-alert dense outlined class="mb-5 font-weight-medium text-justify">
                        Conforme determinação de <strong>ID 10581712116</strong>, proferida em <strong>14/11/2025</strong>,
                        os Termos de Adesão deverão ser assinados através da plataforma do <strong>GOV.BR</strong>.
                    </v-alert>

                    <div class="text-subtitle-2 mb-2">
                        Antes de prosseguir, siga atentamente as orientações abaixo:
                    </div>

                    <v-list dense class="transparent pa-0">
                        <v-list-item class="px-0 min-height-0 mb-2">
                            <v-icon color="primary" small
                                class="mr-3 mt-1 align-self-start">mdi-file-document-outline</v-icon>
                            <v-list-item-content class="pa-0">
                                <span class="body-2">Utilize <strong>somente o último documento gerado</strong> pelo
                                    sistema para
                                    efetuar a assinatura. Documentos antigos serão automaticamente rejeitados;</span>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item class="px-0 min-height-0 mb-2">
                            <v-icon color="primary" small
                                class="mr-3 mt-1 align-self-start">mdi-pencil-off-outline</v-icon>
                            <v-list-item-content class="pa-0">
                                <span class="body-2"><strong>Não altere ou modifique</strong> o documento. Qualquer
                                    edição poderá corromper a estrutura e validação;</span>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item class="px-0 min-height-0 mb-2">
                            <v-icon color="primary" small
                                class="mr-3 mt-1 align-self-start">mdi-content-save-off-outline</v-icon>
                            <v-list-item-content class="pa-0">
                                <span class="body-2"><strong>Não renomeie ou use a função "Salvar como"</strong>.
                                    Gere o documento e utilize o arquivo original diretamente no portal gov.br;</span>

                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item class="px-0 min-height-0 mb-2">
                            <v-icon color="primary" small class="mr-3 mt-1 align-self-start">mdi-printer-off</v-icon>
                            <v-list-item-content class="pa-0">
                                <span class="body-2">Não "imprima como PDF" (Print to PDF), antes e depois da assinatua, 
                                    pois isso irá comprometer a validade do documento.</span>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" text @click="showSignatureInfo = false">
                        Cancelar
                    </v-btn>
                    <v-btn color="primary" depressed @click="confirmAndProceed">
                        Entendi e Prosseguir
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    
        <!-- Dialog de ajuda para assinatura digital -->
        <v-dialog v-model="showHelpSignature" max-width="700" persistent>
            <v-card>

                <v-card-title class="headline d-flex align-center pb-2 primary white--text">
                    <v-icon color="white" large class="mr-3">mdi-draw-pen</v-icon>
                    Procedimento para assinar o documento
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="showHelpSignature = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

              <v-divider></v-divider>

                <v-card-text class="pt-4 pb-0">

                    <v-alert dense outlined icon="mdi-shield-alert-outline" class="mb-4 font-weight-medium text-justify"
                        color="orange darken-2">
                        <span class="orange--text text--darken-2">
                            A assinatura digital deve ser realizada <strong>obrigatoriamente</strong>
                            pelo portal <strong>gov.br</strong>, utilizando conta de nível
                            <strong>Prata</strong> ou <strong>Ouro</strong>. Mesmo que você possua outros
                            métodos ou certificados de autenticação, o documento <strong>não será validado</strong>
                            se assinado por outros meios.
                        </span>
                    </v-alert>

                    <div class="text-subtitle-2 font-weight-bold mb-3 grey--text text--darken-2">
                        Siga o passo a passo abaixo:
                    </div>
                    <v-timeline dense clipped class="mt-0 pt-0 signature-timeline">

                        <v-timeline-item small color="primary" class="mb-2">
                            <div class="body-2">
                                <strong>Gere o documento</strong> clicando em
                                <strong><em>"GERAR PDF"</em></strong>. O arquivo PDF será gerado e salvo na sua
                                pasta de <strong>Downloads</strong>.
                            </div>
                        </v-timeline-item>

                        <v-timeline-item small color="primary" class="mb-2">
                            <div class="body-2">
                                Acesse o portal
                                <a href="https://assinador.iti.br" target="_blank" rel="noopener">
                                    assinador.iti.br
                                    <v-icon x-small color="primary">mdi-open-in-new</v-icon>
                                </a>
                                e faça login com sua conta <strong>gov.br</strong>
                                (nível Prata ou Ouro).
                            </div>
                        </v-timeline-item>

                        <v-timeline-item small color="primary" class="mb-2">
                            <div class="body-2">
                                Siga os procedimentos dentro do portal gov.br e quando solicitado, selecione o arquivo
                                PDF que foi gerado, <strong>sem renomear ou modificar</strong> o documento.
                            </div>
                        </v-timeline-item>

                        <v-timeline-item small color="primary" class="mb-2">
                            <div class="body-2">
                                Conclua o procedimento de assinatura pelo portal gov.br e
                                <strong>baixe o documento assinado</strong>.
                            </div>
                        </v-timeline-item>

                        <v-timeline-item small color="primary" class="mb-2">
                            <div class="body-2">
                                Retorne a esta página do site e finalize o processo enviando o arquivo que foi assinado, clicando em
                                <strong>"Clique aqui para enviar o PDF Assinado"</strong>.
                            </div>
                        </v-timeline-item>
                        
                        <v-timeline-item small color="success" class="mb-2">
                            <div class="body-2">
                                Selecione o arquivo PDF que foi assinado (em geral o nome do arquivo segue o padrão 'termo_adesao_nome_credor_assinado.pdf').
                            </div>
                        </v-timeline-item>

                    </v-timeline>

                    <v-sheet color="red lighten-5" rounded class="pa-3 mb-4 mt-2">
                        <div class="caption font-weight-bold red--text text--darken-2 mb-2 text-uppercase">
                            <v-icon small color="red darken-2" class="mr-1">mdi-alert-circle-outline</v-icon>
                            Atenção — Ações que invalidam o documento:
                        </div>
                        <v-row no-gutters>
                            <v-col cols="12" sm="6">
                                <div class="caption d-flex align-start mb-1">
                                    <v-icon x-small color="red darken-1" class="mr-1 mt-1">mdi-close-circle</v-icon>
                                    Não renomeie o arquivo PDF
                                </div>
                                <div class="caption d-flex align-start mb-1">
                                    <v-icon x-small color="red darken-1" class="mr-1 mt-1">mdi-close-circle</v-icon>
                                    Não use "Salvar como" ou "Imprimir como PDF"
                                </div>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <div class="caption d-flex align-start mb-1">
                                    <v-icon x-small color="red darken-1" class="mr-1 mt-1">mdi-close-circle</v-icon>
                                    Não edite ou modifique o documento PDF
                                </div>
                                <div class="caption d-flex align-start mb-1">
                                    <v-icon x-small color="red darken-1" class="mr-1 mt-1">mdi-close-circle</v-icon>
                                    Não use outros certificados ou assinadores
                                </div>
                            </v-col>
                        </v-row>
                    </v-sheet>

                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="pa-4">

                    <v-spacer></v-spacer>
                
                    <v-btn color="primary" depressed @click="showHelpSignature = false">
                       Fechar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
import 'moment/locale/pt-br';
import axios from 'axios';

import creditorTypes from '@/common/data/adherence-creditor-types.data';
import enumTermOptionsByClass from '@/common/data/adherence-term-option.data';
import optionDetailsByClass from '@/common/data/adherence-term-option-by-type.data';
import { downloadPdfResponse, downloadPdfUrl } from '@/common/util/download-file';
import { cpf, cnpj } from 'cpf-cnpj-validator'

import { eventHub } from '@/main';

import actionEventTypes, { EVENT_TYPE } from '@/common/data/action-event-types.data';
import actionEventSteps, { EVENT_STEP } from '@/common/data/action-event-steps.data';
import UserProfileEditModal from '@/components/creditor/UserProfileEditModal.vue';

export default {
    components: { UserProfileEditModal },

    data: () => ({
        profileModal: false,
        profileReadiness: null,
        process_type: {
            CREDITOR_PLAN_ADHERENCE: 1, //Tela de Adesão ao Plano do Credor
        },
        interestDialog: {
            show: false,
            loading: false,
            selectedClass: null,
            selectedOption: null,
            availableOptions: [], 
            reason: ''
        },
        showSignatureInfo: false,
        showHelpSignature: false,
        trackingUploadContext: false,
        adherenceUserId: null,
        adherenceData: null,
        user: null,
        loadingInitial: true,
        showProcessedContent: false,
        signedPdf: null,
        selectedClass: null,
        selectedClassType: null,
        showClassOptionModal: false,
        creditorTypes,
        enumTermOptionsByClass,
        optionDetailsByClass,
        optionSelect: null,
        optionSelected: null,
        hasMoreClass: null,
        showButtonConfirm: false,
        termLocalTimeUpdate: null,
        dataset: {
            pdfLoadError: false,
            confirmReadPlan: false,
            acceptTerms: false,
            acceptResponsibility: false,
            acceptRemoveAdhesionAgc: false,
            confirmedRead: false,
            documents: [],
            description: '',
            content: '',
            adherence: {},
            downloading: false,
            uploading: false,
            loading: false,
            allowedSignature: false,
            userData: {},
            dataList: {},
            selectedClass: null,
        },
    }),

    watch: {
        isUserDataIncomplete(incomplete) {
            this.showProcessedContent = !incomplete;
        },

        optionSelect(newVal) {
            this.optionSelected = this.getOptionDetailsByClass(this.selectedClassType, newVal);
        },

    },

    computed: {
        hasCreditor() {
            return (
                this.dataset &&
                this.dataset.userData &&
                this.dataset.userData.adjusted_creditor &&
                Object.keys(this.dataset.userData.adjusted_creditor).length > 0
            );
        },

        getOptionLongText() {
            if (
                this.optionDetailsByClass &&
                this.optionDetailsByClass[this.selectedClassType] &&
                this.optionDetailsByClass[this.selectedClassType][this.optionSelect]
            ) {
                return (
                    this.optionDetailsByClass[this.selectedClassType][this.optionSelect].col8 ||
                    "Nenhum detalhe disponível para esta opção."
                );
            }
            return "Nenhum detalhe disponível.";
        },

        allCheckmarksChecked() {
            return (
            this.dataset.confirmReadPlan &&
            this.dataset.acceptTerms &&
            this.dataset.acceptResponsibility &&
            this.dataset.acceptRemoveAdhesionAgc
            );
        },

        isUserDataIncomplete() {
            if (this.profileReadiness) return !this.profileReadiness.ready;

            const userData = this.dataset && this.dataset.userData
                ? this.dataset.userData
                : null;

            if (!userData) return false;

            const missingAddressInfo =
                !userData.address_street ||
                !userData.address_city ||
                !userData.nationality;

            let isCNPJ = false;

            if (userData.registration) {
                isCNPJ = this.isCNPJ(userData.registration);
            }

            if (missingAddressInfo) {
                return true;
            }

            if (!isCNPJ) {
                return false;
            }

            const representatives = Array.isArray(userData.representatives)
                ? userData.representatives
                : [];

            if (representatives.length === 0) {
                return true;
            }

            const hasApprovedRepresentative = representatives.some(rep => rep.status === 1);

            return !hasApprovedRepresentative;
        },

        alertMessage() {

            if (this.profileReadiness) {
                if (this.profileReadiness.missingFields && this.profileReadiness.missingFields.length) {
                    const labels = this.profileReadiness.missingFields.map(item => item.label).join(', ');
                    return `Complete os seguintes dados para continuar: ${labels}.`;
                }
                if (this.profileReadiness.blockers && this.profileReadiness.blockers.length) {
                    return this.profileReadiness.blockers[0].message;
                }
            }

            const userData = this.dataset && this.dataset.userData
                ? this.dataset.userData
                : null;

            if (!userData) {
                return '';
            }

            const missingAddressInfo =
                !userData.address_street ||
                !userData.address_city ||
                !userData.nationality;

            let isCNPJ = false;

            if (userData.registration) {
                isCNPJ = this.isCNPJ(userData.registration);
            }

            if (missingAddressInfo) {
                return 'Seu cadastro está incompleto! Para prosseguir com a adesão ao plano, atualize seus dados cadastrais na área.';
            }

            if (!isCNPJ) {
                return '';
            }

            const representatives = Array.isArray(userData.representatives)
                ? userData.representatives
                : [];

            if (representatives.length === 0) {
                return 'É necessário cadastrar ao menos um representante da empresa para prosseguir com a adesão ao plano.';
            }

            const hasApprovedRepresentative = representatives.some(rep => rep.status === 1);

            if (!hasApprovedRepresentative) {
                return 'Nenhum representante da empresa está aprovado para continuar com a geração e assinatura do termo de adesão.';
            }

            return '';
        },

        isMobile() {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
                || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        },

        planPdfUrl() {
            return `${window.location.origin}/termo-adesao.pdf`;
        },

        planViewerUrl() {
            if (!this.isMobile) {
                return '/termo-adesao.pdf#toolbar=0&navpanes=0&scrollbar=0';
            }

            const encodedUrl = encodeURIComponent(this.planPdfUrl);
            return `https://docs.google.com/viewer?url=${encodedUrl}&embedded=true`;
        },

        processedContent() {
            
            if(!this.dataset.confirmedRead) {
                return '';
            }
            
            if (!this.showProcessedContent) {
                return '';
            }

            if (!this.dataset.content) {
                return '';
            }

            let content = this.dataset.content;

            const today = new Date();
            const localDateFormatted = `${String(today.getDate()).padStart(2, '0')}/${String(today.getMonth() + 1).padStart(2, '0')}/${today.getFullYear()}`;
            const updatedAt = this.dataset.adherence.updated_at;
            const formattedUpdatedAt = updatedAt ? new Date(updatedAt).toLocaleDateString('pt-BR') : localDateFormatted;
            const finalLocalDate = this.termLocalTimeUpdate == null ? formattedUpdatedAt : new Date(this.termLocalTimeUpdate).toLocaleDateString('pt-BR');


            let approvedReps = [];

            if (Array.isArray(this.dataset.userData.representatives)) {
                approvedReps = this.dataset.userData.representatives.filter(rep => rep.status === 1);
            }

            const isCompany = this.isCNPJ(this.dataset.userData.registration);

            let signatureBlock = "";

            if (isCompany && approvedReps.length > 0) {
                const repsText = approvedReps
                    .map(rep => `${rep.name.toUpperCase()}, ${this.getFormattedRegistration(rep.registration)}`)
                    .join(" e ");

                signatureBlock += `, representado por ${repsText}`;
            }

            if (this.dataset.userData.lawyer) {
                const lawyer = this.dataset.userData.lawyer;

                const connector = isCompany && approvedReps.length > 0 ? " e " : " ";

                const lawPhrase = isCompany ? "por intermédio de seu procurador" : "representado por seu procurador";

                signatureBlock += `${connector}${lawPhrase} ${lawyer.name.toUpperCase()}, OAB ${lawyer.federal_registration} - com seccional - ${lawyer.federal_registration_uf}`;
            }

            let creditorClassName = 'CLASSE';
            let amount = 0;

            if (this.hasMoreClass && this.hasMoreClass.length >= 2 && this.selectedClass) {
                const selected = this.hasMoreClass.find(c => c.id === this.selectedClass);
                if (selected) {
                    creditorClassName = selected.name;
                    amount = selected.raw && selected.raw.amount ? selected.raw.amount : 0;
                }
            } else {
                const adjustedCreditor = this.dataset.userData && this.dataset.userData.adjusted_creditor ? this.dataset.userData.adjusted_creditor : {};
                if (adjustedCreditor && typeof adjustedCreditor.type !== 'undefined') {
                    const foundClass = this.creditorTypes.find(c => c.id === adjustedCreditor.type);
                    if (foundClass) {
                        creditorClassName = foundClass.name;
                        amount = adjustedCreditor.amount || 0;
                    }
                }
            }

            const {clause_1, clause_2} = this.getClausesText(this.selectedClassType, this.optionSelect);

            const amountFormatted = new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL',
            }).format(amount);

            const replacements = {
                '{creditor_name}': (this.dataset.userData && this.dataset.userData.name ? this.dataset.userData.name : 'nome do credor').toUpperCase(),
                '{creditor_registration}': this.getFormattedRegistration(this.dataset.userData.registration),
                '{creditor_nationality}': this.dataset.userData.nationality || 'nacionalidade',
                //'{creditor_profission}': this.dataset.userData.profession || 'profissão',
                '{creditor_email}': this.dataset.userData.email || 'email',
                '{creditor_class}': `${creditorClassName}`,
                '{address_city}': this.dataset.userData.address_city || 'cidade',
                '{local_date}': finalLocalDate,
                '{address_street}': this.dataset.userData.address_street || 'Rua',
                '{address_number}': this.dataset.userData.address_number ?
                    this.dataset.userData.address_number +
                    (this.dataset.userData.address_complement ? ' /' : ',')
                    : 'Nº',
                '{address_complement}': this.dataset.userData.address_complement ? `${this.dataset.userData.address_complement},` : '',
                '{address_neighborhood}': this.dataset.userData.address_neighborhood || 'Bairro',
                '{address_state}': this.dataset.userData.address_state || 'Estado',
                '{address_postal_code}': this.dataset.userData.address_postal_code || 'CEP',
                '{creditor_amount}': amountFormatted,
                '{amount_in_words}': this.numberInWords(amount),
                // '{selected_option}': this.selectedTextOption,
                '{selected_option}': this.selectedClassType === 1 ? 'opção de pagamento prevista' : this.selectedTextOption,
                '{representative_name}': signatureBlock,
                '{representative_registration}': '',
                //'{representative_name}': this.isCNPJ(this.dataset.userData.registration) ? ', representado por ' + this.dataset.userData.representative_name || '' : '',
                //'{representative_registration}': this.isCNPJ(this.dataset.userData.registration) ?
                 //   this.getFormattedRegistration(this.dataset.userData.representative_registration) : '',
                '{clause_1}': clause_1,
                '{clause_2}': clause_2
            };

            for (const [token, value] of Object.entries(replacements)) {
                const regex = new RegExp(token.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g');
                content = content.replace(regex, value);
            }

            if (this.optionSelected && this.optionSelect) {
                const optionDescription = this.optionSelected.col8
                    ? `<div style="margin-top: 24px;">${this.optionSelected.col8}</div>`
                    : '';

                if (content.includes('{description_option}')) {
                    content = content.replace('{description_option}', optionDescription);
                } else if (optionDescription) {
                    content += optionDescription;
                }
            } else {
                content = content.replace('{description_option}', '');
            }

            return content;
        },

        selectedTextOption() {
            const optionsForClass = this.enumTermOptionsByClass[this.selectedClassType] || [];
            const selectedOption = optionsForClass.find(opt => opt.value === this.optionSelect);
            return selectedOption ? selectedOption.text : 'Opção';
        },
    },

    async created() {
        if (this.$root.user) {
            this.user = this.$root.user;

            console.log('Iniciando Adesão ao Plano para o usuário:', this.user);
            
            this.dataset.loading = true;

            await this.loadDescription();
            await this.loadPlanAdherenceStatusInformation();
            await this.init();
            
            this.dataset.loading = false;
        }
        
        this.loadingInitial = false;
    },

    methods: {

        async init() {
    
            await this.trackActionEvent({
                eventType: EVENT_TYPE.SCREEN_OPEN,
                step: EVENT_STEP.INIT,
                value: null,
                metadata: {
                    creditor_id: this.adherenceUserId,
                    creditor_name: this.user.name,
                }
            });
        },

        async loadData() {
            this.dataset.loading = true;

            try {
                await this.loadUserData();
                await this.loadProfileReadiness();
                await this.loadObjection();
                await this.loadUserTypeAssociation();
                this.loadingInitial = false;
            } catch (error) {
                console.error(error)
            } finally {
                this.dataset.loading = false;
            }
        },

        async loadProfileReadiness() {
            const response = await axios.get('/api/users/me/profile-readiness', {
                params: { context: 'plan-adherence' }
            });
            this.profileReadiness = response.data.content;
        },

        async handleProfileSaved() {
            await this.loadUserData();
            await this.loadProfileReadiness();
        },

        openRegister() {
            eventHub.$emit("DIALOG-REGISTER", true)
        },

        async readAndAgreePlan(){
            this.dataset.confirmedRead = true;
            await this.loadData();

            await this.trackActionEvent({
                eventType: EVENT_TYPE.CHECKBOX_ALL_CONFIRMED ,
                step: EVENT_STEP.ALL_CONFIRMED,
                value: null,
                metadata: {
                    confirmReadPlan: this.dataset.confirmReadPlan,
                    acceptTerms: this.dataset.acceptTerms,
                    acceptResponsibility: this.dataset.acceptResponsibility,
                    acceptRemoveAdhesionAgc: this.dataset.acceptRemoveAdhesionAgc,
                    creditor_id: this.adherenceUserId,
                    allowedSignature: this.dataset.allowedSignature,
                    hasCreditor: this.hasCreditor
                }
            })
        },

        async loadPlanAdherenceStatusInformation() {

            const response = await axios.get('/api/user/plan-adherence-status-information')

            const result = response.data.content.data

            const data = Array.isArray(result) ? result : [];

            if (data.length > 0 && data[0].user_id) {
                this.adherenceUserId = data[0].user_id
            }

            const allConfirmed = data.length > 0 && data.every(item => Number(item.status) === 1);

            if (allConfirmed) {
                await this.loadData();
                this.dataset.confirmedRead = true;
            }else{
                this.loadingInitial = false;
            }  
        },

        getClausesText(classType, optionSelect) {
            let clause_1 = '';
            let clause_2 = '';

            switch (classType) {
                case 3:
                    switch (optionSelect) {
                        case 1:
                            clause_1 = ', nos termos da Cláusula 8.1 do Plano, ';
                            clause_2 = ', conforme previsto na Cláusula 8.3';
                            break;
                        case 2:
                            clause_1 = ', nos termos da Cláusula 8.1 do Plano, ';
                            clause_2 = ', conforme previsto na Cláusula 8.4';
                            break;
                        case 3:
                            clause_1 = ', nos termos da Cláusula 8.1 do Plano, ';
                            clause_2 = ', conforme previsto na Cláusula 8.5';
                            break;
                        case 4:
                            clause_1 = ', nos termos da Cláusula 8.1 do Plano, ';
                            clause_2 = ', conforme previsto na Cláusula 8.6';
                            break;
                        case 5:
                            clause_1 = ', nos termos da Cláusula 8.1 do Plano, ';
                            clause_2 = ', conforme previsto na Cláusula 8.7';
                            break;
                        default:
                            clause_1 = '';
                            clause_2 = '';
                    }
                    break;

                case 1:
                    switch (optionSelect) {
                        case 1:
                            clause_1 = ' ';
                            clause_2 = ' na Cláusula 7';
                            break;
                        default:
                            clause_1 = '';
                            clause_2 = '';
                    }
                    break;

                case 4:
                    switch (optionSelect) {
                        case 1:
                            clause_1 = ', nos termos da Cláusula 10.1 do Plano, ';
                            clause_2 = ', conforme previsto na Cláusula 10.2';
                            break;
                        case 2:
                            clause_1 = ', nos termos da Cláusula 10.1 do Plano, ';
                            clause_2 = ', conforme previsto na Cláusula 10.3';
                            break;
                        default:
                            clause_1 = '';
                            clause_2 = '';
                    }
                    break;
                    
                default:
                    clause_1 = '';
                    clause_2 = '';
                    break;
            }

            return { clause_1, clause_2 };
        },

        getOptionsByClass(classType) {
            const options = this.enumTermOptionsByClass[classType] || [];
            return options;
        },

        getOptionDetailsByClass(classType, optionValue) {
            const options = this.optionDetailsByClass[classType];
            const details = options && optionValue ? options[optionValue] : null;
            return details;
        },

        getClassTitle(classType) {
            const type = this.creditorTypes.find(t => t.id === classType);
            return type ? type.name : 'Classe Desconhecida';
        },

        async checkEligibleClass(classType) {

            if (this.isUserDataIncomplete) {
                return
            }

            if (!this.dataset.allowedSignature) return;

            if (!classType || ![1, 3, 4].includes(Number(classType))) {
                this.optionSelect = null;
                this.optionSelected = null;
                this.showProcessedContent = false;
                await this.loadContent();
                this.$set(this.dataset, 'content', this.dataset.content);
                await this.loadPlanAdherenceStatus();
                this.showProcessedContent = true;

                return;
            }

            await this.loadPlanAdherenceStatus();

            const planOption = this.dataset.adherence && this.dataset.adherence.plan_option != null
                ? this.dataset.adherence.plan_option
                : null;

            const status = this.dataset.adherence && this.dataset.adherence.status != null
                ? this.dataset.adherence.status
                : null;

            if (planOption !== null && status !== 1) {
                const confirmReplace = await this.$dialog.confirm({
                    text: 'Já foi gerado um arquivo pdf com o termo de adesão. Deseja gerar um novo arquivo e substituir o anterior?',
                    title: 'Termo de Adesão existente!',
                    actions: {
                        false: 'NÃO',
                        true: 'SIM',
                    },
                });

                if (confirmReplace) {
                    this.optionSelect = null;
                    this.optionSelected = null;
                    this.showClassOptionModal = true;
                } else {
                    this.optionSelect = planOption;
                    this.optionSelected = this.getOptionDetailsByClass(classType, planOption);
                    this.showProcessedContent = false;
                    await this.loadContent();
                    this.$set(this.dataset, 'content', this.dataset.content);
                    this.showProcessedContent = true;
                }
            } else if (status === null) {
                this.optionSelect = null;
                this.optionSelected = null;
                this.showClassOptionModal = true;
            } else {
                //this.optionSelect = null;
                this.optionSelect = planOption;
                this.optionSelected = this.getOptionDetailsByClass(classType, planOption);
                //this.optionSelected = null;
                this.showProcessedContent = false;
                await this.loadContent();
                this.$set(this.dataset, 'content', this.dataset.content);
                this.showProcessedContent = true;
            }
        },

        async loadObjection() {
            const response = await axios.get('/api/user-objection-events/request')

            var result = response.data.content

            if (!result || !result.length) {
                this.dataset.allowedSignature = true;
                return
            };

            const reqData = result[0];

            if (reqData.status == 1 || reqData.status == 2 || reqData.status == 3) {
                this.dataset.allowedSignature = true;
                return
            }
        },

        isCNPJ(value) {
            const onlyDigits = (value || '').replace(/\D/g, '');
            return onlyDigits.length === 14;
        },

        getFormattedRegistration(value) {

            if (!value) return 'CPF/CNPJ';

            const cleanValue = value.replace(/\D/g, '');

            return this.isCNPJ(cleanValue) ? `CNPJ: ${cnpj.format(cleanValue)}` : `CPF: ${cpf.format(cleanValue)}`;
        },

        async confirmOption() {
            if (!this.optionSelect) {
                this.$dialog.message.error('Nenhuma opção selecionada. Por favor, selecione uma opção antes de confirmar.');
                return;
            }

            this.showClassOptionModal = false;
            this.showProcessedContent = false;
            this.termLocalTimeUpdate = new Date();
            await this.loadContent();
            //this.$set(this.dataset, 'content', this.dataset.content);
            this.showProcessedContent = true;

            await this.trackActionEvent({
                eventType: EVENT_TYPE.OPTION_SELECTED,
                step: EVENT_STEP.OPTION_SELECTION,
                value: this.optionSelect,
                metadata: {
                    class_type: this.selectedClassType,
                    option_selected: this.optionSelect,
                    creditor_id: this.adherenceUserId,
                }
            })
        },

        onClassChanged() {
            this.showButtonConfirm = true;
            this.dataset.selectedClass = null;
            this.showProcessedContent = false;
        },

        async confirmSelectedClass() {
            if (!this.selectedClass) {
                this.$dialog.message.error('Nenhuma classe selecionada. Por favor, selecione uma classe antes de confirmar.');
                return;
            }

            const selected = this.creditorTypes.find(item => item.id === this.selectedClass);

            if (!selected) {
                return;
            }

            this.selectedClassType = selected.id;
            this.dataset.selectedClass = selected.id;

            await this.checkEligibleClass(this.selectedClassType);

            this.showButtonConfirm = false;

        },

        async confirmReadPlan() {
            if (!this.dataset.confirmedRead) return;


        },

        async loadUserTypeAssociation() {

            try {
                const response = await axios.get('/api/user/plan-adherence-user-type');

                this.$set(this.dataset, 'dataList', response.data || { content: [] });

                const data = this.dataset.dataList.content || [];

                this.hasMoreClass = data.map(item => {
                    const foundClass = this.creditorTypes.find(c => c.id === item.type);
                    return {
                        id: item.type,
                        name: foundClass ? foundClass.name : `Classe ${item.type}`,
                        raw: item
                    };
                });

                if (data.length === 1) {
                    this.selectedClass = data[0].type;
                    this.selectedClassType = data[0].type;
                    this.$set(this.dataset, 'selectedClass', data[0].type);

                    await this.checkEligibleClass(this.selectedClassType);
                }
            } catch (error) {
                this.$dialog.message.error('Erro ao carregar associação de classes.');
                this.$set(this.dataset, 'dataList', { content: [] });
            }
        },

        numberInWords(valor) {
            const unidades = ["", "um", "dois", "três", "quatro", "cinco", "seis", "sete", "oito", "nove"];
            const especiais = ["dez", "onze", "doze", "treze", "quatorze", "quinze", "dezesseis", "dezessete", "dezoito", "dezenove"];
            const dezenas = ["", "", "vinte", "trinta", "quarenta", "cinquenta", "sessenta", "setenta", "oitenta", "noventa"];
            const centenas = ["", "cento", "duzentos", "trezentos", "quatrocentos", "quinhentos", "seiscentos", "setecentos", "oitocentos", "novecentos"];
            const qualificadores = [
                ["", ""],
                ["mil", "mil"],
                ["milhão", "milhões"],
                ["bilhão", "bilhões"],
                ["trilhão", "trilhões"]
            ];

            function numberToLong(n) {
                let resultado = "";

                if (n === 0) return "";

                if (n > 999) {
                    throw new Error("Número fora de faixa para esta função interna.");
                }

                if (n === 100) return "cem";

                const c = Math.floor(n / 100);
                const d = Math.floor((n % 100) / 10);
                const u = n % 10;

                if (c !== 0) resultado += centenas[c];

                if (d === 1) {
                    resultado += (resultado ? " e " : "") + especiais[u];
                } else if (d > 1) {
                    resultado += (resultado ? " e " : "") + dezenas[d];
                    if (u !== 0) resultado += " e " + unidades[u];
                } else if (u !== 0) {
                    resultado += (resultado ? " e " : "") + unidades[u];
                }

                return resultado;
            }

            function generateLong(valor) {
                if (valor === 0) return "zero";

                const partes = [];
                let inteiro = Math.floor(valor);
                let centavos = Math.round((valor - inteiro) * 100);

                const segmentos = [];
                let pos = 0;

                while (inteiro > 0) {
                    segmentos.push(inteiro % 1000);
                    inteiro = Math.floor(inteiro / 1000);
                    pos++;
                }

                for (let i = segmentos.length - 1; i >= 0; i--) {
                    const numero = segmentos[i];
                    if (numero === 0) continue;

                    const texto = numberToLong(numero);
                    const qualificador = qualificadores[i];

                    if (i > 0 && numero === 1) {
                        partes.push(texto + " " + qualificador[0]);
                    } else if (i > 0) {
                        partes.push(texto + " " + qualificador[1]);
                    } else {
                        partes.push(texto);
                    }
                }

                let resultado = partes.join(", ").replace(/, ([^,]*)$/, " e $1");

                if (resultado.endsWith(", ")) {
                    resultado = resultado.slice(0, -2);
                }

                if (resultado.includes(", e")) {
                    resultado = resultado.replace(", e", " e");
                }

                resultado += (Math.floor(valor) === 1 ? " real" : " reais");

                if (centavos > 0) {
                    resultado += " e " + numberToLong(centavos) + (centavos === 1 ? " centavo" : " centavos");
                }

                return resultado;
            }

            return generateLong(parseFloat(valor.toFixed(2)));
        },

        async loadDescription() {

            this.dataset.loading = true

            try {
                const result = await axios.get(`/api/dynamic-infos/keys`, {
                    params: { keys: 'plan-adherence-description' }
                });

                if (result.data.content && result.data.content.length > 0) {
                    this.dataset.description = result.data.content[0].value;
                } else {
                    this.dataset.description = '';
                }

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false
            }
        },

        async loadContent() {

            this.dataset.loading = true

            try {
                const result = await axios.get(`/api/dynamic-infos/keys`, {
                    params: { keys: 'plan-adherence-content' }
                });

                if (result.data.content && result.data.content.length > 0) {
                    this.dataset.content = result.data.content[0].value;
                } else {
                    this.dataset.content = '';
                }

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false
            }
        },

        async loadUserData() {

            try {
                const result = await axios.get(`/api/user/plan-adherence-user`);

                const data = result.data.content.data;

                if (data && Object.keys(data).length > 0) {
                    this.dataset.userData = data;
                } else {
                    this.dataset.userData = {};
                }

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            }
        },

        async confirmAndProceed() {

            this.showSignatureInfo = false
            
            await this.generatePdf();
        },

        async generatePdf() {
            if (this.$moduleBlocked('site.plan_adherence')) return;

            this.dataset.downloading = true

            try {

                const response = await axios.post('/api/user/generate-pdf', {
                    plan_details: this.getPlanDetailsForPdf(),
                    class_type: this.selectedClassType,
                    plan_option: this.optionSelect,
                    confirmed_read_plan: this.dataset.confirmReadPlan,
                    accept_responsibility: this.dataset.acceptResponsibility,
                    accept_terms: this.dataset.acceptTerms,
                    accept_remove_adhesion: this.dataset.acceptRemoveAdhesionAgc
                }, {
                    responseType: 'blob'
                })

                const filename = `termo_adesao_${this.user.name || ''}.pdf`
                await downloadPdfResponse(response, filename, 'Termo de adesão ao plano')

                await this.trackActionEvent({
                    eventType: EVENT_TYPE.PDF_GENERATED,
                    step: EVENT_STEP.PDF_GENERATION,
                    value: null,
                    metadata: {
                        class_type: this.selectedClassType,
                        plan_option: this.optionSelect,
                        file_name: filename,
                        creditor_id: this.adherenceUserId,
                    }
                })

                await this.$dialog.confirm({
                    text: `O arquivo PDF foi gerado com sucesso! Nome do arquivo: <strong>${filename}</strong>.<br><br>
                    Por padrão, o arquivo é salvo na sua pasta de <strong>Downloads</strong> ou na pasta que o seu navegador utiliza para salvar arquivos.<br><br>
                    Após a assinatura, retorne a esta página e faça o upload do arquivo PDF assinado.<br><br>
                    <strong>Obs.:</strong> A assinatura digital deve ser feita através da plataforma <strong>gov.br</strong>, utilizando conta de nível <strong>prata</strong> ou <strong>ouro</strong>.<br><br>`,
                    title: 'PDF Gerado',
                    actions: {
                        true: 'OK'
                    },
                    html: true
                })


            } catch (error) {

                let errorMessage = 'Erro ao gerar/baixar arquivo PDF! Tente novamente.';

                if (error.response && error.response.data instanceof Blob) {
                    try {
                        const text = await error.response.data.text();
                        const json = JSON.parse(text);
                        errorMessage = json.content.error.message || errorMessage;

                    } catch (parseError) {
                        console.error('Erro ao parsear arquivo', parseError);
                    }
                }

                this.$dialog.notify.error(errorMessage, {
                    position: 'top-right',
                    timeout: 5000,
                });
            } finally {
                this.loadPlanAdherenceStatus();
                this.dataset.downloading = false
            }
        },

        async uploadPdf(file) {
            if (this.$moduleBlocked('site.plan_adherence')) return;

            if (!file) return

            this.trackingUploadContext = true;

            this.dataset.uploading = true

            try {
                const formData = new FormData()
                formData.append('signed_pdf', file)

                if (this.selectedClassType !== undefined && this.selectedClassType !== null) {
                    formData.append('class_type', this.selectedClassType);
                }

                const response = await axios.post('/api/user/upload-signed-pdf', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' },
                })

                this.$dialog.notify.info("Arquivo pdf enviado com sucesso!", {
                    position: "top-right",
                    timeout: 5000,
                });

                await this.trackActionEvent({
                    eventType: EVENT_TYPE.PDF_UPLOADED,
                    step: EVENT_STEP.PDF_UPLOAD,
                    metadata: {
                        class_type: this.selectedClassType,
                        option: this.optionSelect,
                        creditor_id: this.adherenceUserId,
                        file: file.name,
                        result: 'SUCCESS'
                    }
                })

                this.signedPdf = null

            } catch (error) {

                const httpStatus = error && error.response && error.response.status ? error.response.status : null;

                const errorCode = (error && error.code) || (error && error.response && error.response.data && error.response.data.code) || null;
                
                let errorMessage = 'Ocorreu um erro ao enviar o PDF. Por favor, tente novamente.';

                if (error.response && error.response.data && error.response.data.content && error.response.data.content.error) {
                    errorMessage = error.response.data.content.error.message;
                } else if (this.$codes(error)) {
                    errorMessage = this.$codes(error);
                }

                await this.$dialog.confirm({
                    text: errorMessage,
                    title: 'Erro no Upload do Documento',
                    actions: {
                        true: 'OK'
                    },
                    html: true
                });

                await this.trackActionEvent({
                    eventType: EVENT_TYPE.PDF_UPLOAD_ERROR,
                    step: EVENT_STEP.PDF_UPLOAD,
                    metadata: {
                        class_type: this.selectedClassType,
                        option: this.optionSelect,
                        creditor_id: this.adherenceUserId,
                        file: file.name || null,
                        error_message: errorMessage,
                        error_code: errorCode,
                        http_status: httpStatus
                    }
                })

                console.error('Erro ao enviar PDF:', error)

            } finally {
                //this.loadPlanAdherenceStatus();
                const adherence = await this.loadPlanAdherenceStatus();

                if (this.trackingUploadContext && adherence.status != null) {
                    await this.trackUploadResult(adherence.status)
                }

                this.trackingUploadContext = false
                this.dataset.uploading = false
            }
        },

        getColorByStatus(status) {

            switch (status) {
                case 0:
                    return 'warning'
                case 1:
                    return 'green'
                case 2:
                    return 'important'
                default:
                    break
            }
        },

        getTextByStatus(status) {
            switch (status) {
                case 0:
                    return 'Aguardando assinatura'
                case 1:
                    return 'Assinado'
                case 2:
                    return 'Rejeitado'
                default:
                    break
            }
        },

        async loadPlanAdherenceStatus() {

            this.dataset.loading = true;

            try {

                const response = await axios.get('/api/user/plan-adherence-status', {
                    params: {
                        class_type: this.selectedClassType
                    }
                });

                const adherenceData = response &&
                    response.data &&
                    response.data.content &&
                    response.data.content.data;

                this.dataset.adherence = (adherenceData && Object.keys(adherenceData).length > 0)
                    ? adherenceData
                    : {};

                return this.dataset.adherence;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
            }
        },

       
        async savePdfFromIframe() {
            await downloadPdfUrl('/termo-adesao.pdf', 'termo-adesao.pdf', 'Termo de adesão ao plano');
        },

        openPlanPdf() {
            window.open(this.planPdfUrl, '_blank', 'noopener');
        },

        getPlanDetailsForPdf() {
            return this.processedContent || this.dataset.content || '';
        },

        getActionEventUserId(metadata = null) {
            return this.adherenceUserId
                || (this.user && this.user.id)
                || (metadata && metadata.creditor_id)
                || null;
        },

        async trackActionEvent({
            eventType,
            step = null,
            value = null,
            metadata = null,
            }) {
            try {
                const userId = this.getActionEventUserId(metadata);

                if (!userId) {
                    console.warn('Evento de adesão não enviado: user_id ausente.', {
                        eventType,
                        step,
                        value,
                        metadata,
                    });
                    return;
                }

                const payload = {
                    process_type: this.process_type.CREDITOR_PLAN_ADHERENCE,
                    event_type: eventType,
                    step,
                    value,
                    metadata,
                    user_id: userId
                }

                await axios.post('/api/action-events', payload)

            } catch (error) {
                console.warn('Erro ao registrar evento:', error)
            }
        },

        async trackUploadResult(status) {

            if (status === 1) {
                await this.trackActionEvent({
                    eventType: EVENT_TYPE.PROCESS_FINISHED,
                    step: EVENT_STEP.FINISHED,
                    metadata: { 
                        creditor_id: this.adherenceUserId,
                        result: 'APPROVED'
                    }
                })
            }

            if (status === 0) {
                await this.trackActionEvent({
                    eventType: EVENT_TYPE.PDF_UPLOADED,
                    step: EVENT_STEP.PDF_UPLOAD,
                    metadata: {
                        creditor_id: this.adherenceUserId,
                        result: 'PENDING'
                    }
                })
            }

            if (status === 2) {
                await this.trackActionEvent({
                    eventType: EVENT_TYPE.PDF_UPLOADED,
                    step: EVENT_STEP.PDF_UPLOAD,
                    metadata: {
                        creditor_id: this.adherenceUserId,
                        result: 'REJECTED'
                    }
                })
            }
        },

        handleInterestChange() {
            this.interestDialog.show = true;
            
            this.interestDialog.selectedClass = this.dataset.adherence ? this.dataset.adherence.type : null;
            this.onInterestClassChanged(this.interestDialog.selectedClass);
           
        },

        onInterestClassChanged(classId) {
            
            this.interestDialog.selectedOption = null;
            
            const optionsForClass = this.enumTermOptionsByClass[classId] || [];
            
            this.interestDialog.availableOptions = optionsForClass;
            
        },

        async submitInterestChange() {
            if (this.$moduleBlocked('site.plan_adherence')) return;
            
            this.interestDialog.loading = true;
            
            const payload = {
                id: this.dataset.adherence ? this.dataset.adherence.id : null,
                interest_plan_option: this.interestDialog.selectedOption
            };

            try {
               
                await axios.post('/api/user/update-interest-plan-option', payload);
                
                this.$dialog.notify.success('Interesse em alterar opção manifestado com sucesso!');
                this.interestDialog.show = false;
            } catch (error) {
                this.$dialog.notify.error('Erro ao enviar solicitação.');
            } finally {
                this.interestDialog.loading = false;
            }
        },

        currentOptionText() {
    
            const currentOptionId = this.dataset.adherence ? this.dataset.adherence.plan_option : null;

            if (!currentOptionId) return 'Não selecionada';

            const allOptions = this.enumTermOptionsByClass[3] || [];
            const found = allOptions.find(opt => opt.value === currentOptionId);
            
            return found ? found.text : 'Opção ' + currentOptionId;
        },

    }
};
</script>

<style lang="scss">
    .title-page {
        color: var(--v-primary-base);
        font-family: "Raleway";
        font-size: 40px;
        font-style: normal;
        font-weight: 700;
        line-height: 38px;
    }

    .min-height-0 {
        min-height: 0 !important;
    }

    .plan-pdf-viewer {
        border: 1px solid #d8deea;
        border-radius: 8px;
        overflow: hidden;
        background: #fff;
    }

    .plan-pdf-toolbar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        padding: 12px 16px;
        border-bottom: 1px solid #d8deea;
        background: #f8fafc;
    }

    .plan-pdf-actions {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: flex-end;
    }

    .plan-pdf-frame {
        display: block;
        width: 100%;
        height: 70vh;
        min-height: 560px;
    }

    @media (max-width: 600px) {
        .plan-pdf-toolbar {
            align-items: flex-start;
            flex-direction: column;
            padding: 12px;
        }

        .plan-pdf-actions {
            width: 100%;
            gap: 8px;
            justify-content: flex-start;
        }

        .plan-pdf-actions .v-btn {
            margin-right: 0 !important;
        }

        .plan-pdf-frame {
            height: 72vh;
            min-height: 520px;
        }
    }
</style>
